export default {
    gray:      'gray',
    graySmall: 'graySmall',
    red:       'red',
    redSmall:  'redSmall',
};